import { render, staticRenderFns } from "./AdditionalPDFOptions.vue?vue&type=template&id=2f355d72&scoped=true"
import script from "./AdditionalPDFOptions.vue?vue&type=script&lang=ts"
export * from "./AdditionalPDFOptions.vue?vue&type=script&lang=ts"
import style0 from "./AdditionalPDFOptions.vue?vue&type=style&index=0&id=2f355d72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f355d72",
  null
  
)

export default component.exports